<template>
  <div class="messages">
    <transition name="slide" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'messages-view'
}
</script>

<style lang="scss" scoped>

</style>
